module.exports = __webpack_public_path__ + "img/qfecard-logo.dbdd3381.svg";